import React, { useState, useEffect, useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import { randomColor } from "randomcolor";
import Draggable from "react-draggable";
import "./App.css";

function App() {
    const [item, setItem] = useState("");
    const [items, setItems] = useState(JSON.parse(localStorage.getItem("items")) || []);
    const wrapperRef = useRef(null);

    const newItem = () => {
        if (item.trim() !== "") {
            const wrapperWidth = wrapperRef.current.offsetWidth;
            const wrapperHeight = wrapperRef.current.offsetHeight;

            const newItem = {
                id: uuidv4(),
                item,
                color: randomColor({
                    luminosity: "light",
                }),
                defaultPos: {
                    x: Math.floor(Math.random() * (wrapperWidth - 200)),
                    y: Math.floor(Math.random() * (wrapperHeight - 200)),
                },
            };
            setItems((items) => [...items, newItem]);
            setItem("");
        } else {
            alert("Enter something");
            setItem("");
        }
    };

    const deleteNode = (id) => {
        setItems(items.filter((item) => item.id !== id));
    };

    const updatePos = (data, index) => {
        let newArray = [...items];
        newArray[index].defaultPos = { x: data.x, y: data.y };
        setItems(newArray);
    };

    const keyPress = (e) => {
        const code = e.keyCode || e.which;
        if (code === 13) {
            newItem();
        }
    };

    useEffect(() => {
        localStorage.setItem("items", JSON.stringify(items));
    }, [items]);

    useEffect(() => {
        const handleResize = () => {
            const wrapperWidth = wrapperRef.current.offsetWidth;
            const wrapperHeight = wrapperRef.current.offsetHeight;
            const maxX = wrapperWidth - 200;
            const maxY = wrapperHeight - 200;

            const updatedItems = items.map((item) => {
                const { defaultPos } = item;
                const updatedX = Math.min(defaultPos.x, maxX);
                const updatedY = Math.min(defaultPos.y, maxY);
                return {
                    ...item,
                    defaultPos: { x: updatedX, y: updatedY },
                };
            });

            setItems(updatedItems);
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [items]);

    return (
        <div className="App">
            <div className="wrapper" ref={wrapperRef}>
                <div className="input-container">
                    <input
                        value={item}
                        type="text"
                        placeholder="Enter something"
                        onChange={(e) => setItem(e.target.value)}
                        onKeyPress={(e) => keyPress(e)}
                    />
                    <button className="enter" onClick={newItem}>
                        Enter
                    </button>
                </div>
                {items.map((item, index) => (
                    <Draggable
                        key={item.id}
                        defaultPosition={item.defaultPos}
                        bounds="parent"
                        onStop={(_, data) => {
                            updatePos(data, index);
                        }}
                    >
                        <div className="todo__item" style={{ backgroundColor: item.color }}>
                            {item.item}
                            <button className="delete" onClick={() => deleteNode(item.id)}>
                                X
                            </button>
                        </div>
                    </Draggable>
                ))}
            </div>
        </div>
    );
}

export default App;
